"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    inputChipVariants: ()=>inputChipVariants
});
const index_cjs_namespaceObject = require("../../variants/index.cjs");
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const commonVariants = {
    disabled: index_cjs_namespaceObject.chipDisabledVariants,
    elevated: index_cjs_namespaceObject.chipElevatedVariants,
    emphasis: index_cjs_namespaceObject.chipEmphasisVariants
};
const inputChipVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: index_cjs_namespaceObject.inputChipSlots,
    variants: {
        size: index_cjs_namespaceObject.inputChipSizeVariants,
        ...commonVariants
    },
    compoundVariants: [
        ...index_cjs_namespaceObject.chipCompoundVariants,
        {
            elevated: true,
            className: {
                containerSlot: 'hover:aria-selected:shadow-none'
            }
        },
        {
            emphasis: [
                'regular',
                'medium',
                'bold'
            ],
            className: {
                containerSlot: 'hover:aria-selected:shadow-none'
            }
        }
    ],
    defaultVariants: index_cjs_namespaceObject.inputChipDefaultVariants
});
exports.inputChipVariants = __webpack_exports__.inputChipVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "inputChipVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
